import { CollectionFunction } from 'data/collectionFunction/collectionFunction.types';
import { adaptToEdit, adaptXtpXdpConnectionList } from './xtp-xdp-connection.adapters';
import {
  GET_XTP_XDP_CONNECTION_LIST_PENDING,
  GET_XTP_XDP_CONNECTION_LIST_FULFILLED,
  SELECT_XTP_XDP_CONNECTION,
  UPDATE_XTP_XDP_CONNECTION_ERRORS,
  GET_XTP_XDP_CONNECTION_FULFILLED,
  GET_XTP_XDP_CONNECTION_PENDING,
  XtpActionTypes,
  XtpXdpConnectionState,
} from './xtp-xdp-connection.types';

const initialState: XtpXdpConnectionState = {
  entities: [],
  single: undefined,
  selected: [],
  errors: { connection: '', protocols: [] },
  ui: {
    isLoading: false,
    wasDataUpdatedWithErrors: false,
  }
};

export default function xtpReducer(
  state = initialState,
  action: XtpActionTypes,
): XtpXdpConnectionState {
  switch (action.type) {
    case GET_XTP_XDP_CONNECTION_LIST_PENDING:
      return {
        ...state,
        selected: [],
        ui: {
        ...state.ui,
        isLoading: true
      }
    };

    case GET_XTP_XDP_CONNECTION_LIST_FULFILLED:
      return {
        ...state,
        entities: adaptXtpXdpConnectionList(action.payload.data.data || []),
        single: undefined,
        ui: {
          ...state.ui,
          isLoading: false
        }
      };

    case UPDATE_XTP_XDP_CONNECTION_ERRORS:
      return {
        ...state,
        errors: action.payload,
        ui: {
          ...state.ui,
          wasDataUpdatedWithErrors: action.payload.connection !== '' || action.payload.protocols.length !== 0,
        }
      };

    case SELECT_XTP_XDP_CONNECTION:
      return {
        ...state,
        selected: action.payload || [],
      };

    case GET_XTP_XDP_CONNECTION_PENDING:
        return {
          ...state,
          ui: {
          ...state.ui,
          isLoading: true
        }
      };

    case GET_XTP_XDP_CONNECTION_FULFILLED:

      return {
        ...state,
        single: adaptToEdit(action?.payload?.data?.data?.[0] as CollectionFunction, state.entities, state.selected),
        ui: {
          ...state.ui,
          isLoading: false
        }
      };

    default:
      return state;
  }
}
